import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import { createGnrSupplier, updateGnrSupplier, GnrSupplier, GnrSupplierResponse, UpdateGnrSupplierBody, CreateGnrSupplierBody } from '../../services/apiSLTP/sites/gnrSuppliers';

type UseUpdateGnrSupplierMutationOptions = MutationOptions<GnrSupplierResponse, Error, { gnrSupplierId: string; data: UpdateGnrSupplierBody }>;

type UseCreateGnrSupplierMutationOptions = MutationOptions<GnrSupplierResponse, Error, CreateGnrSupplierBody>;

export const useUpdateGnrSupplierMutation = (options?: UseUpdateGnrSupplierMutationOptions) => {
    const gnrSupplierMutation: MutationFunction<GnrSupplierResponse, { gnrSupplierId: string; data: UpdateGnrSupplierBody }> = async ({ gnrSupplierId, data }) => {
        try {
            const response: GnrSupplierResponse = await updateGnrSupplier(gnrSupplierId, data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during gnrSupplier');
        }
    };

    return useMutation(gnrSupplierMutation, options);
};

export const useCreateGnrSupplierMutation = (options?: UseCreateGnrSupplierMutationOptions) => {
    const gnrSupplierMutation: MutationFunction<GnrSupplierResponse, CreateGnrSupplierBody> = async (data) => {
        try {
            const response: GnrSupplierResponse = await createGnrSupplier(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during gnrSupplier');
        }
    };

    return useMutation(gnrSupplierMutation, options);
};
